<template>
    <div class="container">
        <back-button location="/technologies"></back-button>

        <h1 class="title">Data</h1>
        <div class="logo swing-animation">
            <img src="../../assets/images/Data.svg"/>
        </div>
        <div class="content">
            <div class="data-analysis-methods-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Data analysis methods and techniques used by Entelectuals</p>
                    <apex-charts type="bar" height="300" :options="dataAnalysisMethodsDataSource.chartOptions"
                                 :series="dataAnalysisMethodsDataSource.series"
                                 class="chart"></apex-charts>
                </div>
                <p class="fun-fact">Tensorflow, Kafka, Spark, and Elastic are the most used framworks in data science</p>
            </div>
            <div class="data-type-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Types of data Entelectuals use when conducting data analysis</p>
                    <apex-charts type="radialBar" :options="dataTypesDataSource.chartOptions"
                                 :series="dataTypesDataSource.series" class="chart"></apex-charts>
                </div>
                <p class="fun-fact">Logistic regression, linear regression, decision forests, and neural networks are the most used data science algorithms</p>
            </div>
            <div class="data-storage-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Data Warehousing is widely used, however, more and more work is being
                        done with Data Lakes</p>
                    <apex-charts type="bar" :options="dataStorageDataSource.chartOptions"
                                 :series="dataStorageDataSource.series" class="chart"></apex-charts>
                </div>
                <p class="fun-fact">59% of data science projects are driven by the respective business unit, whilst 39% are driven by the IT/Technology department</p>
            </div>
            <div class="data-analysis-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">The majority of data analysis conducted is descriptive, however
                        prescription and prediction is becoming more important</p>
                    <apex-charts type="donut" :options="dataAnalysisDataSource.chartOptions"
                                 :series="dataAnalysisDataSource.series" class="chart"></apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueApexCharts from "vue-apexcharts/src";
    import BackButton from "../../widgets/BackButton";

    export default {
        components: {
            'apex-charts': VueApexCharts,
            BackButton
        },
        data: function () {
            return {
                dataAnalysisMethodsDataSource: {
                    chartOptions: {
                        chart: {
                            toolbar: {
                                show: false
                            }
                        },
                        colors: ['#8EC63F', '#008AD0', '#B51E8E', '#D8181F', '#00994C', '#009EA5', '#F7941D'],
                        labels: [
                            'Logistic Regression',
                            'Linear Regression',
                            'Clustering K-means',
                            'Random Forests',
                            'Neural Networks',
                            'Bayesian Techniques',
                            'Ensemble Techniques',
                        ],
                        plotOptions: {
                            bar: {
                                columnWidth: '45%',
                                distributed: true,
                                horizontal: true,
                            }
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        yaxis: {
                            categories: [
                                'Logistic Regression',
                                'Linear Regression',
                                'Clustering K-means',
                                'Random Forests',
                                'Neural Networks',
                                'Bayesian Techniques',
                                'Ensemble Techniques',
                            ],
                            labels: {
                                style: {
                                    colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff'],
                                    fontSize: '14px'
                                }
                            }
                        },
                        xaxis: {
                            labels: {
                                style: {
                                    colors: '#FFF',
                                },
                            }
                        },
                        tooltip: {
                            theme: 'dark',
                            y: {
                                formatter: (value) => `${value}%`
                            },
                            marker: {
                                show: true
                            }
                        },
                    },
                    series: [{
                        name: 'Analysis Techniques',
                        data: [27.8, 22.2, 27.8, 30.6, 19.4, 5.6, 22.2]
                    }]
                },
                dataTypesDataSource: {
                    chartOptions: {
                        chart: {
                            toolbar: {
                                show: false
                            }
                        },
                        colors: ['#8EC63F', '#008AD0', '#B51E8E', '#D8181F', '#00994C', '#009EA5', '#F7941D'],
                        labels: ['Relational', 'Text', 'Image', 'Social Media', 'Metric & Time series'],
                        tooltip: {
                            y: {
                                formatter: (value) => `${value}%`
                            }
                        },
                        stroke: {
                            width: 0
                        },
                        fill: {
                            patern: {
                                width: 500
                            }
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                show: false,
                            },
                            formatter: function (val, opt) {
                                if (val < 5)
                                    return '';
                                return `${opt.w.globals.labels[opt.seriesIndex]}: ${val}%`;
                            },
                        },
                        plotOptions: {
                            radialBar: {
                                offsetY: -40,
                                startAngle: 0,
                                endAngle: 280,
                                hollow: {
                                    margin: 5,
                                    size: '14%',
                                    background: 'transparent',
                                    image: undefined,
                                },
                                track: {
                                    opacity: 0.1
                                },
                                dataLabels: {
                                    name: {
                                        show: false,
                                    },
                                    value: {
                                        color: '#fff',
                                        offsetY: 4
                                    }
                                }
                            }
                        },
                        legend: {
                            show: true,
                            floating: true,
                            fontSize: '16px',
                            position: 'left',
                            verticalAlign: 'top',
                            textAnchor: 'end',
                            labels: {
                                useSeriesColors: true,
                            },
                            markers: {
                                size: 0
                            },
                            itemMargin: {
                                vertical: 4,
                            },
                            containerMargin: {
                                left: 160,
                                top: 10
                            }
                        },
                        responsive: [{
                            breakpoint: 599,
                            options: {
                                legend: {
                                    show: true,
                                    fontSize: '16px',
                                    position: 'bottom',
                                    textAnchor: 'start',
                                    labels: {
                                        useSeriesColors: false,
                                        color: '#fff'
                                    },
                                    markers: {
                                        size: 5
                                    },
                                    containerMargin: {
                                        left: 0,
                                        top: 0
                                    }
                                },
                                plotOptions: {
                                    radialBar: {
                                        offsetY: 0,
                                        startAngle: 270,
                                        endAngle: 90,
                                    }
                                },
                            }
                        }]
                    },
                    series: [80.6, 25, 5.6, 2.8, 2.8]
                },
                dataStorageDataSource: {
                    chartOptions: {
                        chart: {
                            stacked: true,
                            stackType: '100%',
                            toolbar: {
                                show: false
                            }
                        },
                        dataLabels: {
                            formatter: (val) => {
                                if (val < 5) {
                                    return '';
                                }

                                return `${Math.round(val)}%`;
                            }
                        },
                        colors: ['#B51E8E', '#009EA5'],
                        plotOptions: {
                            bar: {
                                horizontal: true,
                            }
                        },
                        legend: {
                            position: 'top',
                            labels: {
                                color: '#FFF'
                            }
                        },
                        yaxis: {
                            show: false,
                            labels: {
                                show: false
                            }
                        },
                        xaxis: {
                            labels: {
                                style: {
                                    colors: '#FFF',
                                },
                            },
                            categories: ['Storage']
                        },
                        tooltip: {
                            theme: 'dark',
                            y: {
                                formatter: (value) => `${value}%`
                            }
                        },
                    },
                    series: [{
                        name: 'Data Warehousing',
                        data: [74.2]
                    }, {
                        name: 'Data lakes',
                        data: [25.8]
                    }],
                },
                dataAnalysisDataSource: {
                    chartOptions: {
                        chart: {
                            toolbar: {
                                show: false
                            }
                        },
                        legend: {
                            labels: {
                                color: '#FFF'
                            },
                            position: 'bottom',
                        },
                        colors: ['#F7941D', '#008AD0', '#B51E8E', '#009EA5'],
                        labels: ['Descriptive', 'Prescriptive', 'Predictive'],
                        tooltip: {
                            enabled: true,
                            y: {
                                formatter: (value) => `${value}%`
                            }
                        },
                        stroke: {
                            width: 0
                        },
                        fill: {
                            patern: {
                                width: 500
                            }
                        },
                        plotOptions: {
                            pie: {
                                donut: {
                                    size: '50%',
                                },
                            }
                        },
                        dataLabels: {
                            formatter: (val) => `${Math.round(val)}%`
                        }
                    },
                    series: [53.7, 26.8, 19.5],
                }
            }
        },
        methods: {
            track () {
                this.$ga.page('/2018/technology/data') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 600px 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: 'back title   logo' 'content content content';
        color: white;
        text-align: center;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .logo {
            grid-area: logo;
            height: 160px;
            width: 160px;
            align-self: start;
            justify-self: end;
            background: $green;
            border-bottom-left-radius: 100%;
            display: grid;

            @media only screen and (max-width: $screen-xs-max) {
                display: none;
            }

            img {
                width: 50%;
                height: 50%;
                align-self: start;
                justify-self: end;
                margin: 20px;
            }
        }

        .title {
            grid-area: title;
            align-self: center;
            justify-self: center;
            align-content: center;
            justify-content: center;
            margin: 24px;
            display: grid;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. methods type     .' '. storage analysis .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto auto;

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-areas: '. methods .' '. type .' '. storage .' '. analysis .';
                grid-template-columns: 1fr 2fr 1fr;
            }

            .fun-fact {
                align-self: center;
                justify-self: center;
                margin: 24px;
            }

            .chart {
                width: 360px;
                align-self: center;
                justify-self: center;

                @media only screen and (max-width: $screen-xs-max) {
                    width: 250px;
                }
            }

            .chart-group {
                border-left: 2px solid $entelect-orange;
                padding-left: 24px;
                margin-bottom: 16px;
                display: grid;
            }

            .chart-title {
                align-self: start;
                justify-self: start;
            }

            .chart-sub-title {
                align-self: start;
                justify-self: start;
                text-align: left;
                margin-bottom: 24px;
            }

            .data-type-chart {
                grid-area: type;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .data-analysis-methods-chart {
                grid-area: methods;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .data-analysis-chart {
                grid-area: analysis;
                display: grid;
                padding-top: 24px;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .data-storage-chart {
                grid-area: storage;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                    margin: 0;
                }
            }
        }
    }
</style>
